var $def = require('./$.def');

$def($def.S + $def.F, 'Object', {classof: require('./$.classof')});